import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../store';
import {
  selectStationAssignmentData,
  setSelectedHalf,
} from '../../store/slices/stationAssignmentSlice';
import { ROUTES } from '../../utils/constants';
import StationAssignmentTabs from '../StationAssignmentTabs';
import ShiftRosterPage from '../../pages/stationAssignment/shiftRoster';
import AssignmentsPage from '../../pages/stationAssignment/assignments';

/**
 * StationAssignmentLayout component that provides persistent tabs and nested routing
 * for the station assignment workflow. Reads date/shift/half from Redux store.
 * Mirrors the ShiftPlanLayout pattern.
 */
const StationAssignmentLayout: React.FC = () => {
  const dispatch = useAppDispatch();

  // Get station assignment data from Redux store
  const { selectedDate, selectedShift, selectedHalf, isStationAssignmentActive } =
    useAppSelector(selectStationAssignmentData);

  // If no station assignment is active, redirect to the station assignment landing page.
  if (!isStationAssignmentActive || !selectedDate || !selectedShift) {
    return <Navigate to={ROUTES.SHIFT_ROTATION} replace />;
  }

  const handleHalfChange = (half: string) => {
    dispatch(setSelectedHalf(half));
  };

  return (
    <StationAssignmentTabs
      date={selectedDate}
      shiftType={selectedShift}
      selectedHalf={selectedHalf ?? 'firstHalfStationAssignment'}
      onHalfChange={handleHalfChange}
    >
      <Routes>
        {/* Default route - redirect to shift-roster */}
        <Route path="/" element={<Navigate to="shift-roster" replace />} />

        {/* Tab content routes */}
        <Route path="/shift-roster" element={<ShiftRosterPage />} />
        <Route path="/assignments" element={<AssignmentsPage />} />

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="shift-roster" replace />} />
      </Routes>
    </StationAssignmentTabs>
  );
};

export default StationAssignmentLayout;
